import { useState, useRef, useEffect } from "react"
import { useParams } from 'react-router-dom'

import Grid from '@material-ui/core/Grid'

import Dialog from '@base/Dialog'
import { ButtonCancel, ButtonSave } from '@base/Button/ButtonForm'
import TextField from '@base/Inputs/Text'
import DatePicker from '@base/Inputs/DatePicker'
import Toast from '@base/Toast'

import EscolaService from '@services/EscolaService'

import { ProcessoResolver } from "@helpers/ProcessoHelper";
import { parseDate, toDate } from '@helpers/DateHelper'

export const Processo = (props) => {

	const [eticket, setEticket]							= useState("");
	const [dataLimitePostagem, setDataLimitePostagem] 	= useState("");

    const params = useParams();
	let processo = ProcessoResolver(params.processo);

	const toastRef = useRef(null);

	const buttonsSubmit = () =>
		<>
			<ButtonSave onClick={submit} />
			<ButtonCancel onBack={fecharModal} />
		</>

	const submit = () => {
		if (!(eticket && dataLimitePostagem)) {
			toastRef.current.show("error", "Preencha todos os campos com asterisco!");
		} else {
            const escola = {
                eticket: eticket,
                dataLimitePostagem: toDate(dataLimitePostagem),
            }

            EscolaService.editar(processo.id, props.codigoInep, escola).then(resultado => {
                fecharModal();
                toastRef.current.show("success", "Informações da Escola Salvas com Sucesso!");
            }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Editar Informações da Escola!"));
		}
	};

	useEffect(() => {
        EscolaService.listarPorCodigoInepOuEticket(processo.id, props.codigoInep).then(resultado => {
            const { codigoEticket, dataLimitePostagem } = resultado.data;

            setEticket(codigoEticket);
            setDataLimitePostagem(parseDate(dataLimitePostagem));
        }).catch(error => toastRef.current.show("error", "Ocorreu um problema ao Buscar Informações da Escola!"));
	}, [processo, props.codigoInep]);

	const tituloModal = () => "Editar Informações da Escola";

	const fecharModal = () => {
		props.handleClose();

		setEticket("");
		setDataLimitePostagem("");
	};

	return (
        <>
            <Toast ref={toastRef} />

            <Dialog
                maxWidth={"sm"}
                fullWidth={true}
                closeDialog={props.handleClose}
                openDialog={props.open}
                title={tituloModal()}
                actions={buttonsSubmit()}
            >
                <Grid container spacing={3}>
                    <Grid item lg={12}>
                        <TextField
                            label='E-Ticket'
                            required
                            value={eticket}
                            name="eticket"
                            autoComplete="off"
                            onChange={(e) => setEticket(e.target.value)}
														autoFocus
                        />
                    </Grid>

                    <Grid item lg={12}>
                        <DatePicker
                            label={"Data Limite de Postagem"}
                            required
                            value={dataLimitePostagem}
                            name="dataLimitePostagem"
                            onChange={(e) => setDataLimitePostagem(e)}
                            disabled={false}
                        />
                    </Grid>
                </Grid>
            </Dialog>
        </>
	);
}

export default Processo;
